export default "/images/1763e628c6c1b934a880f4969e56ce1f.avif";